import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../../../config/ApiEndpoint.js';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgClose } from '../../../../shared/assets/close.js';
import '../../../../utils/constants/colors.js';
import { usePreventPageScroll } from '../../../../shared/utils/hooks/usePreventPageScroll/usePreventPageScroll.js';
import '../../../../shared/consts/index.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import { useTransition } from '../../../../utils/hooks/useTransition/useTransition.js';
import 'react-dom';
import { Typography } from '../../../Typography/Typography.js';
import '../../../ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { classNames } from '../../../../utils/functions/classNames/classNames.js';
import 'react-focus-lock';
import '../../../Transition/ZoomTransition/ZoomTransition.js';
import '../../../Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../Transition/OpacityTransition/OpacityTransition.js';
import { IconButton } from '../../../IconButton/IconButton.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';

const IN_DURATION = 300;
const OUT_DURATION = 400;
const ActionList = ({ children, className = '', title, isOpen, setIsOpen, }) => {
    const { mount, stage, currentDuration } = useTransition({
        inDuration: IN_DURATION,
        isShown: isOpen,
        outDuration: OUT_DURATION,
    });
    usePreventPageScroll(isOpen);
    const transitionClassname = classNames({
        'action-list__container--entering': stage === 'ENTERING',
        'action-list__container--exiting': stage === 'EXITING',
    });
    if (!mount) {
        return null;
    }
    return (jsxs("div", Object.assign({ style: {
            animationDuration: `${currentDuration}ms`,
        }, className: classNames('action-list__container', transitionClassname, className), "data-testid": 'draggable-mobile-menu' }, { children: [jsxs("div", Object.assign({ className: 'dropdown-header' }, { children: [jsx(Typography, Object.assign({ className: 'dropdown-header__title', variant: 'title', color: 'secondary' }, { children: title })), jsx(IconButton, Object.assign({ className: 'dropdown-header__icon', onClick: () => setIsOpen(false) }, { children: jsx(SvgClose, {}) }))] })), jsx("div", Object.assign({ "data-testid": 'dropdown-list', className: 'action-list__content' }, { children: children }))] }), 'dropdown'));
};

export { ActionList, IN_DURATION, OUT_DURATION };
